import { jsxs as C, jsx as y } from "react/jsx-runtime";
import { c as G } from "./clsx-OuTLNxxd.js";
import * as j from "react";
import H, { useContext as D, useRef as k, useState as S, useMemo as N, useEffect as x, cloneElement as J } from "react";
import { M as U, d as g, a as Q, _ as W, b as X, P as Y, s as E } from "./popup-D0oeoBA-.js";
import { useMap as p } from "./components/elements/map/map.hook.js";
function M(t, e) {
  if (!t)
    throw new Error(e);
}
function ee(t, e, n, o) {
  if (M(n.id === o.id, "layer id changed"), M(n.type === o.type, "layer type changed"), n.type === "custom" || o.type === "custom")
    return;
  const { layout: a = {}, paint: s = {}, filter: r, minzoom: l, maxzoom: c, beforeId: u } = n;
  if (u !== o.beforeId && t.moveLayer(e, u), a !== o.layout) {
    const f = o.layout || {};
    for (const i in a)
      g(a[i], f[i]) || t.setLayoutProperty(e, i, a[i]);
    for (const i in f)
      a.hasOwnProperty(i) || t.setLayoutProperty(e, i, void 0);
  }
  if (s !== o.paint) {
    const f = o.paint || {};
    for (const i in s)
      g(s[i], f[i]) || t.setPaintProperty(e, i, s[i]);
    for (const i in f)
      s.hasOwnProperty(i) || t.setPaintProperty(e, i, void 0);
  }
  g(r, o.filter) || t.setFilter(e, r), (l !== o.minzoom || c !== o.maxzoom) && t.setLayerZoomRange(e, l, c);
}
function te(t, e, n) {
  if (t.style && t.style._loaded && (!("source" in n) || t.getSource(n.source))) {
    const o = { ...n, id: e };
    delete o.beforeId, t.addLayer(o, n.beforeId);
  }
}
let oe = 0;
function ne(t) {
  const e = D(U).map.getMap(), n = k(t), [, o] = S(0), a = N(() => t.id || `jsx-layer-${oe++}`, []);
  if (x(() => {
    if (e) {
      const r = () => o((l) => l + 1);
      return e.on("styledata", r), r(), () => {
        e.off("styledata", r), e.style && e.style._loaded && e.getLayer(a) && e.removeLayer(a);
      };
    }
  }, [e]), e && e.style && e.getLayer(a))
    try {
      ee(e, a, t, n.current);
    } catch (r) {
      console.warn(r);
    }
  else
    te(e, a, t);
  return n.current = t, null;
}
let ae = 0;
function re(t, e, n) {
  if (t.style && t.style._loaded) {
    const o = { ...n };
    return delete o.id, delete o.children, t.addSource(e, o), t.getSource(e);
  }
  return null;
}
function le(t, e, n) {
  M(e.id === n.id, "source id changed"), M(e.type === n.type, "source type changed");
  let o = "", a = 0;
  for (const r in e)
    r !== "children" && r !== "id" && !g(n[r], e[r]) && (o = r, a++);
  if (!a)
    return;
  const s = e.type;
  s === "geojson" ? t.setData(e.data) : s === "image" ? t.updateImage({
    url: e.url,
    coordinates: e.coordinates
  }) : "setCoordinates" in t && a === 1 && o === "coordinates" ? t.setCoordinates(e.coordinates) : "setUrl" in t && o === "url" ? t.setUrl(e.url) : "setTiles" in t && o === "tiles" ? t.setTiles(e.tiles) : console.warn(`Unable to update <Source> prop: ${o}`);
}
function se(t) {
  const e = D(U).map.getMap(), n = k(t), [, o] = S(0), a = N(() => t.id || `jsx-source-${ae++}`, []);
  x(() => {
    if (e) {
      const r = () => setTimeout(() => o((l) => l + 1), 0);
      return e.on("styledata", r), r(), () => {
        var l;
        if (e.off("styledata", r), e.style && e.style._loaded && e.getSource(a)) {
          const c = (l = e.getStyle()) === null || l === void 0 ? void 0 : l.layers;
          if (c)
            for (const u of c)
              u.source === a && e.removeLayer(u.id);
          e.removeSource(a);
        }
      };
    }
  }, [e]);
  let s = e && e.style && e.getSource(a);
  return s ? le(s, t, n.current) : s = re(e, a, t), n.current = t, s && j.Children.map(t.children, (r) => r && J(r, {
    source: a
  })) || null;
}
const ie = import("./maplibre-gl-MLeNA0jH.js").then((t) => t.m), ce = j.forwardRef(function(e, n) {
  return Q(e, n, ie);
}), $ = X, fe = W, z = ne, ue = se, I = "#f7a800";
function ye({
  longitude: t,
  latitude: e,
  radiusInMeters: n,
  color: o = "primary",
  opacity: a = 0.2,
  strokeWidth: s = 2
}) {
  const [r, l] = S(I);
  x(() => {
    const f = getComputedStyle(document.documentElement);
    l(f.getPropertyValue(`--color-${o}`) || I);
  }, [o]);
  const c = Array.from({ length: 64 }, (f, i) => {
    const m = i / 64 * 2 * Math.PI, L = e + n / O * Math.cos(m);
    return [t + n / (O * Math.cos(e * Math.PI / 180)) * Math.sin(m), L];
  });
  return c.push(c[0]), /* @__PURE__ */ C(ue, { type: "geojson", data: {
    type: "Feature",
    geometry: {
      type: "Polygon",
      coordinates: [c]
    },
    properties: {}
  }, children: [
    /* @__PURE__ */ y(
      z,
      {
        type: "fill",
        paint: {
          "fill-color": r,
          "fill-opacity": a
        }
      }
    ),
    /* @__PURE__ */ y(
      z,
      {
        type: "line",
        paint: {
          "line-color": r,
          "line-width": s
        }
      }
    )
  ] });
}
const O = 111320, de = H.forwardRef(
  ({
    initialViewState: t = {
      longitude: 2.3522,
      latitude: 48.8566,
      zoom: 13
    },
    bounds: e,
    circleLayer: n,
    markers: o,
    singleMarker: a,
    popup: s,
    mapStyle: r,
    padding: l,
    className: c,
    onMoveEnd: u,
    onDragEnd: f,
    onResize: i,
    debounceEventsTime: m = 300,
    positionNavControl: L = "top-left",
    maxZoom: b = 19,
    minZoom: v = 0,
    randomPosition: B = !1,
    id: P = "1",
    centerMarker: h
  }, T) => {
    var w, R;
    const { mapRef: A, singleMarker: d, debouncedOnMoveEnd: F, handleDragEnd: K, debouncedOnResize: V, handleMapLoad: q } = p({
      initialSingleMarker: a,
      randomPosition: B,
      id: P,
      onMoveEnd: u,
      onDragEnd: f,
      onResize: i,
      debounceEventsTime: m,
      ref: T
    });
    return /* @__PURE__ */ C("div", { className: G(E["map-container"], c), children: [
      /* @__PURE__ */ C(
        ce,
        {
          ref: A,
          initialViewState: {
            ...t,
            bounds: e,
            fitBoundsOptions: {
              padding: {
                top: (l == null ? void 0 : l.top) ?? 10,
                bottom: (l == null ? void 0 : l.bottom) ?? 10,
                left: (l == null ? void 0 : l.left) ?? 10,
                right: (l == null ? void 0 : l.right) ?? 10
              }
            }
          },
          mapStyle: r,
          dragRotate: !1,
          style: { width: "100%", height: "100%" },
          onMoveEnd: F,
          onResize: V,
          minZoom: v,
          maxZoom: b,
          onLoad: q,
          children: [
            n && /* @__PURE__ */ y(ye, { ...n }),
            s && /* @__PURE__ */ y(Y, { ...s }),
            /* @__PURE__ */ y(fe, { showCompass: !1, position: L }),
            o && o.map((_, Z) => /* @__PURE__ */ y($, { ..._, children: _.content }, Z)),
            d && /* @__PURE__ */ y(
              $,
              {
                longitude: d.longitude,
                latitude: d.latitude,
                draggable: d.draggable,
                onDragEnd: K,
                children: d.content
              }
            )
          ]
        }
      ),
      h && /* @__PURE__ */ y(
        "div",
        {
          className: E["center-marker"],
          style: { transform: `translate(${((w = h.offset) == null ? void 0 : w.x) ?? 0}px, ${((R = h.offset) == null ? void 0 : R.y) ?? 0}px)` },
          children: h.content
        }
      )
    ] });
  }
);
de.displayName = "MapBox";
export {
  ye as C,
  de as M,
  O
};
